'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = require('react');
var PropTypes = React.PropTypes;

var Toggle = function (_React$Component) {
  _inherits(Toggle, _React$Component);

  function Toggle() {
    var _temp, _this, _ret;

    _classCallCheck(this, Toggle);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleChange = function (e) {
      _this.props.onChange(e.target.checked);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Toggle.prototype.render = function render() {
    var className = 'cf-toggle';

    if (this.props.value) {
      className += ' cf-toggle--active';
    }

    return React.createElement(
      'label',
      { htmlFor: this.props.name, className: className },
      React.createElement('input', {
        className: 'cf-toggle__checkbox',
        type: 'checkbox',
        id: this.props.name,
        name: this.props.name,
        checked: this.props.value,
        onChange: this.handleChange,
        onFocus: this.props.onFocus,
        onBlur: this.props.onBlur }),
      React.createElement(
        'span',
        { className: 'cf-toggle__label' },
        this.props.label
      ),
      React.createElement('span', { className: 'cf-toggle__handle' })
    );
  };

  return Toggle;
}(React.Component);

Toggle.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([false])]).isRequired,
  name: PropTypes.string,
  value: PropTypes.bool,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func
};


module.exports = Toggle;